import { render, staticRenderFns } from "./HuaxianVillageInfo.vue?vue&type=template&id=5ec71657&scoped=true&"
import script from "./HuaxianVillageInfo.vue?vue&type=script&lang=js&"
export * from "./HuaxianVillageInfo.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianVillageInfo.vue?vue&type=style&index=0&id=5ec71657&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec71657",
  null
  
)

export default component.exports